import React, { Fragment } from "react";
import { connect } from "react-redux";

import {
  mapStateToProps,
  FloatingButtonsContainer
} from "components/FloatingButtons/FloatingButtonsContainer";
import FloatingButtons from "./FloatingButtons";
import TourModalContainer from "components/shared/Tour/TourModal/TourModalContainer";

export class CustomFloatingButtonsContainer extends FloatingButtonsContainer {
  constructor() {
    super();
    this.state = {
      isMobilePage: true, // for defining mobile Project page
      showTourModal: false /* Custom: Tour modal */
    };

    /* Custom: binding of handleOpenTourModal and handleCloseTourModal */
    this.handleOpenTourModal = this.handleOpenTourModal.bind(this);
    this.handleCloseTourModal = this.handleCloseTourModal.bind(this);
  }

  /* Custom: new function */
  handleOpenTourModal() {
    this.setState({
      showTourModal: true
    });
  }

  /* Custom: new function */
  handleCloseTourModal() {
    this.setState({
      showTourModal: false
    });
  }

  /* Custom: new function */
  renderTourModal() {
    return (
      <TourModalContainer
        projectId={this.props.project ? this.props.project.id || null : null}
        showModal={this.state.showTourModal}
        handleCloseModal={this.handleCloseTourModal}
        language={this.props.language}
      />
    );
  }

  /* Custom: renderTourModal(), and enclosing FloatingButtons (and Tour Modal) with a Fragment */
  render() {
    const IS_MOBILE_PROJECT_PAGE = !!(
      this.state.isMobilePage &&
      this.props.floatingButtonsState === "projecthome"
    );
    const HAS_BUTTONS = !!this.props.buttons;
    const HAS_VALID_STATE = !!this.props.floatingButtonsState;
    const HAS_PROJECT = !!(this.props.project && this.props.project.id);
    const PROJECT_ID = this.props.project
      ? this.props.project.id || null
      : null;

    if (
      IS_MOBILE_PROJECT_PAGE ||
      !HAS_BUTTONS ||
      !HAS_VALID_STATE ||
      !HAS_PROJECT
    ) {
      return null;
    } else {
      return (
        <Fragment>
          <FloatingButtons
            buttons={this.props.buttons}
            projectId={PROJECT_ID}
            language={this.props.language}
            /* Custom: handleOpenTourModal */
            handleOpenTourModal={this.handleOpenTourModal}
          />
          {this.state.showTourModal && this.renderTourModal()}
        </Fragment>
      );
    }
  }
}

export default connect(mapStateToProps)(CustomFloatingButtonsContainer);
